// extracted by mini-css-extract-plugin
export default {"track":"Toggle_track__qhwy5","on":"Toggle_on__MBOeB","thumb":"Toggle_thumb__AB0KC"};